import {Inject, Injectable} from 'ng-metadata/core';
import {getVid} from "../../appConfig/appConfigForward";

@Injectable()
export class ChaptersAndReviewsItemService {
    private GET_ITEM_API_URL: string;
    private vid = getVid();

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') restBaseURLs,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService) {

        this.GET_ITEM_API_URL= restBaseURLs.pnxBaseURL;
    }

    public getItem(){
        let url = this.GET_ITEM_API_URL +'/' + this.$stateParams.context + '/' + this.$stateParams.docid +'?vid=' + this.vid + '&lang=' + this.$translate.use();
        return this.$http.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/chaptersAndReviews/chaptersAndReviewsItem.service.ts